//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as axios from "@/store/http";
import * as auth from "@/utils/auth";

export default {
    name: "pubElTree",
    props: {
        treeID: String,
        treecode: String,
        elTreeClick: Function,
        scon: String,
        cond:{
            type:String,
            default:''
        },
        flowsysid:{
            type:String,
            default:''
        },
        showCheckbox: {
            type: Boolean,
            default: false
        }, // 显示复选框
        lazy: {
            type: Boolean,
            default: true
        }, // 是否懒加载
        isfilter: {
            type: Boolean,
            default: false
        }, // 是否过滤
    },
    components: {},
    data() {
        return {
            requestUrl: "tree/load",
            requestParams: {
                contentType : "application/json",
                treecode: this.treecode,
                scon: this.scon,
                cond: this.cond,
                headers : {
                    "ffToken" : auth.getToken()
                }
            },
            expendKeys: [],
            treeProps: {
                // children: 'children',
                label: "name",
                isLeaf: "leaf"
            },
            treeData: [],
            filterText: '',
    }
    },
    methods: {
        // 获取数据
        getData(url, params, callback) {
            if(this.flowsysid!=""){
                params.flowsysid=this.flowsysid;
                params.sysid=this.flowsysid;
            }
            axios.post(url, params)
                .then(( response ) => {
                    let resData = response.data;
                    let treeData = resData.data.treedata;
                    
                    if(resData.code === "1") {
                        callback(treeData);

                        this.toExpend(treeData)
                    } else {
                        let message = resData.msg;
                        console.log('2019年11月13日11:16:57 TreeTag.vue[描述]——[message] :',message);
                    }
                });
        },
        // 处理 elementui 树数据结构
        handleTreeData(handleData) {
            handleData.forEach((currentValue) => {
                if(currentValue.children) {
                    this.handleTreeData(currentValue.children);
                } 

                if(currentValue.isParent === "false") {
                    currentValue.leaf = true;
                }
            });            
        },
        // 第一级只有一个菜单时，展开第第二级
        toExpend(treeData) {
            if(treeData.length == 1) {
                this.expendKeys.push(treeData[0].id);
            }
        },
        init() {
            this.getData(this.requestUrl, this.requestParams, (treeData) => {
                this.handleTreeData(treeData);
                this.treeData = treeData;
            });
        },
        loadNode(node, resolve) {
            node.data ? this.requestParams.id = node.data.id : "";

            this.getData(this.requestUrl, this.requestParams, (treeData) => {
                this.handleTreeData(treeData);
                return resolve(treeData);
            });
        },
        handleNodeClick(data) {
          if(data.nocheck=='false'||!this.isNotNullOrEmpty(data.nocheck)){
            this.elTreeClick && this.elTreeClick(data);
          }
        },
        getCheckedNodes(){
          let nodes=this.$refs[this.treeID].getCheckedNodes();
          return nodes;
        },
        filterNode(value, data) {
          if (!value) return true;
          return data.name.indexOf(value) !== -1;
        }
    },
    mounted() {
        !this.lazy && this.init();
    },
    watch: {
      filterText(val) {
        this.$refs[this.treeID].filter(val);
      }
    },
}



// WEBPACK FOOTER //
// ./src/pccomponents/TreeTag.vue